module.exports = __webpack_public_path__ + "static/media/14BMCAmuralfinished.0254a1a6.webp";